import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getLatestArticles, siteInfo } from "@/utils/content";

const stats = [
  { value: "5", label: "大内容领域" },
  { value: "4,600+", label: "条爆料记录" },
  { value: "每日", label: "持续更新" },
];

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();
  const ticker = getLatestArticles(7);

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const kw = keyword.trim();
    navigate(kw ? `/category/all?q=${encodeURIComponent(kw)}` : "/category/all");
  };

  return (
    <section className="relative w-full" aria-label="品牌首屏">
      <div className="relative h-[560px] w-full overflow-hidden md:h-[640px]">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20dark%20cinematic%20abstract%20city%20rooftop%20at%20night%20with%20warm%20coral%20neon%20glow%20and%20floating%20geometric%20shapes%2C%20moody%20atmosphere%20with%20deep%20shadows%20for%20text%20contrast%2C%20editorial%20poster%20art%2C%20no%20people&width=1600&height=900&seq=hero-511-baoliao&orientation=landscape"
          alt="511爆料品牌首屏背景，夜幕下的城市天台与暖色霓虹光晕"
          title="511爆料 - 分类导航快速直达入口"
          className="absolute inset-0 h-full w-full object-top object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/80 via-background-950/55 to-background-950/85" />

        <div className="relative z-10 mx-auto flex h-full w-full max-w-6xl flex-col justify-center px-4 pt-20 md:px-8">
          <p className="animate-fade-up flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-accent-300">
            <span className="inline-block h-px w-8 bg-accent-400" />
            分类导航 · 快速直达
          </p>

          <h1 className="animate-fade-up mt-5 max-w-3xl font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
            想吃哪类瓜，<span className="text-accent-400">直接进</span>
          </h1>

          <p className="animate-fade-up mt-5 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
            511爆料分类导航覆盖<strong className="font-semibold text-background-50">娱乐圈瓜、职场瓜、校园瓜、同城瓜、行业瓜</strong>，
            分类清晰、更新快，热门小众都能找到，按图索骥不迷路。
          </p>

          <form onSubmit={handleSearch} className="animate-fade-up mt-8 w-full max-w-xl">
            <div className="flex flex-col gap-2 rounded-lg bg-background-50/95 p-2 backdrop-blur sm:flex-row sm:items-center">
              <span className="hidden h-6 w-6 items-center justify-center text-foreground-500 sm:flex">
                <i className="ri-search-2-line text-lg" />
              </span>
              <input
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="输入关键词，例如：面试、选课、探店"
                className="w-full flex-1 bg-transparent px-3 py-2 text-sm text-foreground-900 outline-none placeholder:text-foreground-500"
                aria-label="搜索爆料关键词"
              />
              <button
                type="submit"
                className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                搜索爆料
              </button>
            </div>
          </form>

          <div className="animate-fade-up mt-7 flex flex-wrap items-center gap-3">
            <a
              href="#categories"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400"
            >
              <i className="ri-compass-3-line" />
              进入分类导航
            </a>
            <Link
              to="/category/all"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
            >
              查看全部爆料
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <dl className="animate-fade-up mt-10 flex flex-wrap gap-8">
            {stats.map((item) => (
              <div key={item.label}>
                <dt className="sr-only">{item.label}</dt>
                <dd className="font-heading text-2xl font-bold text-background-50 md:text-3xl">{item.value}</dd>
                <dd className="mt-1 text-xs text-background-100">{item.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>

      <div className="border-y border-background-200 bg-background-100">
        <div className="mx-auto flex max-w-6xl items-center gap-4 px-4 py-3 md:px-8">
          <span className="flex shrink-0 items-center gap-1 text-xs font-semibold text-primary-600">
            <i className="ri-flashlight-fill" />
            刚刚更新
          </span>
          <div className="relative min-w-0 flex-1 overflow-hidden">
            <div className="flex w-max animate-marquee items-center gap-8">
              {[...ticker, ...ticker].map((item, index) => (
                <Link
                  key={`${item.id}-${index}`}
                  to={`/article/${item.id}`}
                  className="whitespace-nowrap text-xs text-foreground-600 transition-colors hover:text-primary-600"
                >
                  {item.title}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
      <span className="sr-only">{siteInfo.slogan}</span>
    </section>
  );
}